import { LoaderFunctionArgs } from 'react-router-dom';
import { api } from '../lib/api';
import { queryClient } from '../providers/query-client';
import { fetchFeatureStatus, featureStatusQueryKey } from '../hooks/use-org-feature-status';

// Features the visit-form may surface AI affordances for. Prefetched alongside the
// form fetch so the coordination-of-care section has feature-status data ready on
// first paint — no flash-of-unavailable-button.
const VISIT_FORM_PREFETCH_FEATURES = ['NOTE_SUMMARY'] as const;

export async function formLoader({ params }: LoaderFunctionArgs) {
    const { branchId, admissionId, formId } = params;
    if (branchId && admissionId && formId) {
        const formPromise = queryClient.fetchQuery({
            queryKey: ['branch', branchId, 'admission', admissionId, 'form', formId],
            queryFn: async () => {
                const { data } = await api.visitForm.get(formId, branchId, admissionId);
                return data;
            },
            staleTime: 60000,
        });

        // Status prefetches are best-effort — a failure here should not block opening
        // the form. The hook will retry on mount if the cache is empty.
        const statusPromises = VISIT_FORM_PREFETCH_FEATURES.map((featureType) =>
            queryClient
                .prefetchQuery({
                    queryKey: featureStatusQueryKey(featureType),
                    queryFn: () => fetchFeatureStatus(featureType),
                    staleTime: 60_000,
                })
                .catch(() => undefined),
        );

        const [form] = await Promise.all([formPromise, ...statusPromises]);
        return form;
    }
    return null;
}
